export default __webpack_public_path__ + "static/media/reload.5ed1d09c.svg";